{
  "version": "/../s3/3.3.1",
  "sentry_dsn": "",
  "deploy_url": "https://d2z8edzz48ni5t.cloudfront.net/appic-web-shop/3.3.1/"
}
